import { Type, type Static } from "@sinclair/typebox";
export const SupplierPurchasesQuerySchema = Type.Object(
  {
    supplierKey: Type.String({ minLength: 1, maxLength: 300 }),
    search: Type.Optional(Type.String({ maxLength: 200 })),
    year: Type.Optional(Type.Integer({ minimum: 2024, maximum: 9999 })),
    sort: Type.Optional(
      Type.Union([Type.Literal("quantity"), Type.Literal("amount")], {
        default: "quantity",
      }),
    ),
    limit: Type.Optional(
      Type.Integer({ minimum: 1, maximum: 200, default: 100 }),
    ),
    offset: Type.Optional(Type.Integer({ minimum: 0, default: 0 })),
  },
  { additionalProperties: false },
);
export type SupplierPurchasesQuery = Static<
  typeof SupplierPurchasesQuerySchema
>;
export interface SupplierRentalDetail {
  invoiceNumber: string | null;
  date: string | null;
  contract: string | null;
  objectReference: string | null;
  description: string;
  quantity: string | null;
  netAmount: string | null;
}
export interface SupplierPurchasedArticle {
  key: string;
  code: string | null;
  description: string;
  unit: string | null;
  currency: string;
  quantity: string | null;
  netAmount: string | null;
  unitPrice: string | null;
  invoiceCount: number;
  incomplete: boolean;
  rentalDetails: SupplierRentalDetail[];
}
export interface SupplierPurchasesPage {
  supplierKey: string;
  supplierName: string;
  items: SupplierPurchasedArticle[];
  totalItems: number;
  nextOffset: number | null;
  documentCount: number;
  missingDetailCount: number;
  notes: string[];
}
